import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TextParagraph } from "react-bootstrap-icons";
import TypeForfait from "./typeforfait";

export default function TypeForfaits() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);

    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    // const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [name, setName] = useState("");
    const [abrev, setAbrev] = useState("");

    const getCompte = async () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.token);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(
            `${config.secure.BASE_URL}:${config.secure.PORT}/${config.secure.PROJECT}/compte/profile`,
            requestOptions
        )
            .then((response) => {
                if (response?.status !== 200) {
                    // console.log("response get account", response);
                } else {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // let body = data?.body;
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: textes.fr.sessionexpmsg } });
                            } else {
                                // console.log("fail request get account");
                            }
                        }
                    });
                }
            })
            .catch((err) => {
                // console.log("error", err);
            });
    };

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=tforfait&limit=${config.secure.limit}&page=${p + 1}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);

                        setElementsList(clientarray);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    // comportements
    useEffect(() => {
        getCompte();
        getElementsList(page);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("nomtab", "tforfait");
        urlencoded.append("lib", name);
        urlencoded.append("abrev", abrev);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        showSuccesMessage(textes.fr.typeforfaitaddedlabel);
                        setAddstate(false);
                        getElementsList(0);
                        setName("");
                        setAbrev("");
                        setFetching(false);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };

    // console.log("abrev type select: ", typem['abrev']);

    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {/* <button onClick={() => navigate(-1)} data-toggle="tooltip" title={textes.fr.back} data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>{textes.fr.back}</span>
                                    </button> */}

                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newtypeforfaitlabel}
                                                onClick={() => setAddstate(true)}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newtypeforfaitlabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.typeforfaitinfoslabel
                                                : textes.fr.listtypeforfaitlabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            <th>{textes.fr.libellelabel}</th>
                                                            <th>{textes.fr.abreviationlabel}</th>
                                                            <th className="text-center">
                                                                {textes.fr.actionlabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={4} className="text-center">
                                                                    {textes.fr.notypeforfaitfound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                <TypeForfait
                                                                    tforfait={item}
                                                                    position={config.app.limit * page + index}
                                                                    key={index}
                                                                />
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="name" className="mb-1">
                                                                    {textes.fr.libellelabel}
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="name">
                                                                        <TextParagraph />
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={textes.fr.enterlibellelabel}
                                                                        value={name}
                                                                        onChange={(e) => setName(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="abrev" className="mb-1">
                                                                    {textes.fr.abreviationlabel}
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="abrev">
                                                                        <TextParagraph />
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={
                                                                            textes.fr.enterabreviationlabel
                                                                        }
                                                                        value={abrev}
                                                                        onChange={(e) => setAbrev(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.newtypeforfaitlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                name
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setName("");
                                                                setAbrev("");
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
